import isServer from "./isServer";

export function setCookie(name, value, expirationTime) {
  if (!isServer()) {
    let expires = "";
    if (expirationTime) {
      const date = new Date();
      date.setTime(date.getTime() + expirationTime);
      expires = "; expires=" + date.toGMTString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
  }
}

/**
 * Deletes all cookies on logout.
 * @param {String} name
 * @returns {Boolean}
 * @public
 */
 export function deleteAllCookies() {
  var cookies = document.cookie.split(";");

  for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}
/**
 * Gets cookie value for a given cookie name from the browser.
 * @param {String} name - Cookie name.
 * @returns {String} Cookie value.
 * @public
 */
export function getCookieByName(name) {
  const value = "; " + document.cookie;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2)
    return parts
      .pop()
      .split(";")
      .shift();
}
